import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './index.css';
import HeadBlock from './HeadBlock';

class GlobalStyles extends Component {
  static propTypes = {
    /** set this if you want to include the XING Sans font */
    withWebfont: PropTypes.bool,
    /** renders the children */
    children: PropTypes.node,
  };

  static defaultProps = {
    withWebfont: true,
  };

  static displayName = 'GlobalStyles';

  render() {
    const { withWebfont } = this.props;

    return (
      <div>
        <HeadBlock withWebfont={withWebfont} />
        {React.Children.only(this.props.children)}
      </div>
    );
  }
}

export default GlobalStyles;
